import { Observable } from 'rxjs/Observable';
import { Constant, BaseComponent } from '../../../../../../infrastructure/common';
import { Component, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { AnnouncementService } from 'app/infrastructure/services/transaction/op/announcement';
import { UserService } from 'app/infrastructure/services/base/security/user.service';

declare var jQuery: any;

@Component({
    selector: 'page-announcement',
    templateUrl: './announcement.html',
    styleUrls: ['./announcement.css'],
})

export class AnnouncementComponent extends BaseComponent implements AfterViewInit {

    announcementList: any[];
    isLoading: boolean = false;
    isExistData: boolean = true;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private announcementService: AnnouncementService,
        private sanitized: DomSanitizer,
        private userService: UserService) {
            super();
        }

    ngOnInit(): void {
        this.getActiveAnnouncementList();
    }

    ngAfterViewInit(): void {
    }

    getActiveAnnouncementList(): void {
        let self = this;
        self.isLoading = true;

        let ownerCode: string = (this.token.DefaultOwnerCode) ? this.token.DefaultOwnerCode : '';
        self.executeWebApi(self.announcementService.GetActiveAnnouncementList(ownerCode)).then(
            message => {
                self.isLoading = false;
                self.announcementList = message.Result;

                if (self.announcementList && self.announcementList.length > 0) {
                    self.isExistData = self.announcementList.length > 0;

                    self.announcementList.forEach(announcement => {
                        let announcementHtml = this.sanitized.bypassSecurityTrustHtml(announcement.AnnouncementContent);
                        announcement.AnnouncementContent = announcementHtml;
                    });
                }
                else {
                    self.isExistData = false;
                    //self.router.navigate(['pages/create-order']);
                    self.isCustodian();
                }
            },
            error => {
                self.isExistData = false;
                self.isLoading = false;
            }
        );
    }

    isCustodian(): void {
        let self = this;        
        self.userService.isCustodian()
          .subscribe(data => {
            let message = data;
    
            if (message && message.MessageType && message.MessageType.Value) {
              if (message.MessageType.Value === Constant.MessageType.success) {
                self.router.navigate(['pages/inventory-product']);
              }else{
                self.router.navigate(['pages/create-order']);
              }            
            } else {
                self.router.navigate(['pages/create-order']);
            }
          },
          error => {
            self.router.navigate(['pages/create-order']);
          });
    }

    showCreateOrder() {
        this.router.navigate(['pages/create-order']);
    }

    executeWebApi(fn: Observable<any>): Promise<any> {
        let self = this;
        let promise = new Promise((resolve, reject) => {
            fn.subscribe(
                message => {
                    if (message && message.MessageType && message.MessageType.Value) {
                        if (message.MessageType.Value == Constant.MessageType.success) {
                            resolve(message);
                        }
                        else {
                            self.showMessage(message.MessageType.Value,
                                            message.MessageNumber,
                                            message.Message,
                                            message.AdditionalInformation);
                        }
                    }
                    else {
                        self.showMessage(Constant.MessageType.error,
                                        Constant.MessageNumber.defaultError,
                                        Constant.Message.defaultError,
                                        null);
                    }
                    reject();
                },
                error => {
                    self.showMessage(Constant.MessageType.error,
                                    Constant.MessageNumber.defaultError,
                                    Constant.Message.defaultError,
                                    error);
                    reject();
                },
                () => {}
            );
        });

        return promise;
    }

    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        jQuery('#PopupMessageTitle').html(title);
        jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));
        jQuery('#PopupMessage').modal('show');
    }

    showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''));
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/master/op/announcement/announcement/announcement.component.ts